<template>
  <div class="mx-5 mx-md-16 px-md-16">
    <v-data-table
      :headers="headers"
      :items="rows.items"
      :items-per-page="-1"
      hide-default-footer
      disable-sort
      class="elevation-1 rounded-lg"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="editCashDesks(item)"
          ><v-icon small color="orange">fa-edit</v-icon></v-btn
        >
        <v-btn icon @click="deleteCashDesks(item)"
          ><v-icon small color="red">fa-trash</v-icon></v-btn
        >
      </template>
    </v-data-table>
    <div class="pt-2 d-flex flex-column flex-md-row align-center justify-end">
      <span class="font-quicksand">Filas por páginas: </span>
      <span style="width: 50px" class="mx-md-2">
        <v-select
          v-model="itemsPerPage"
          :items="itemsPerPages"
          class="font-quicksand"
          @change="onItemsPerPageChange"
        ></v-select>
      </span>
      <span class="font-quicksand"
        >{{ rowsRangeStart }}-{{ rowsRangeEnd }} de {{ rows.totalItems }}
      </span>
      <v-pagination
        v-model="page"
        :length="rows.totalPages"
        :total-visible="pageVisible"
        color="red"
        class="font-work-sans"
        @input="onPageChange"
      ></v-pagination>
    </div>

    <dialog-cash-desk
      :cashDesk="cashDesk"
      :del="del"
      :dialog="dialog"
      @dismiss="
        () => {
          dialog = false
          loadData()
        }
      "
    />

    <form-dialog
      :cashDesk="cashDesk"
      :edit="edit"
      :dialog="dialog2"
      @dismiss="
        () => {
          dialog2 = false
          loadData()
        }
      "
    />
  </div>
</template>

<script>
import Repository from '@/repositories/RepositoryFactory'
import { createPaginationMixin } from '@/mixins/pagination'
import DialogCashDesk from './Dialog.vue'
import FormDialog from './FormDialog.vue'
const CashDeskRepository = Repository.get('cashDesks')

export default {
  components: { DialogCashDesk, FormDialog },
  name: 'ActiveCashDesks',
  props: ['search', 'newItem'],
  mixins: [createPaginationMixin({ debounceMs: 500 })],
  data: () => ({
    headers: [
      {
        text: 'Número',
        align: 'center',
        class:
          'primary white--text rounded-tl-lg font-weight-bold text-subtitle-2',
        value: 'number',
      },
      {
        text: 'Descripción',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'description',
      },
      {
        text: 'Opciones',
        align: 'center',
        class:
          'primary white--text rounded-tr-lg font-weight-bold text-subtitle-2',
        value: 'actions',
      },
    ],
    itemsPerPages: [10, 20, 30, 50, 100],
    del: true,
    edit: true,
    cashDesk: null,
    dialog: false,
    dialog2: false,
  }),
  watch: {
    newItem: function (val) {
      if (val) this.loadData()
    },
  },
  methods: {
    fetchPage: function (params) {
      return CashDeskRepository.get(params)
    },
    deleteCashDesks: function (item) {
      this.cashDesk = item
      this.dialog = true
    },
    editCashDesks: function (item) {
      this.cashDesk = Object.assign({}, item)
      this.dialog2 = true
    },
  },
}
</script>
